"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ScreenSize_1 = __importDefault(require("@web/common/ScreenSize"));
(() => {
    const benefitsQuestionBoxes = Array.from(document.querySelectorAll('.subscription-how-it-works-benefits .most-frequent-questions .question-container'));
    const navigations = Array.from(document.querySelectorAll('.subscription-how-it-works-benefits .scroll-control'));
    const benefitsFirstColumn = document.querySelector('.subscription-how-it-works-benefits .benefits-box');
    function getActiveBox(boxes) {
        var _a;
        return (_a = boxes.filter((box) => box.classList.contains('active'))[0]) !== null && _a !== void 0 ? _a : null;
    }
    function showBenefit(benefitBox) {
        if (benefitsFirstColumn === null || ScreenSize_1.default.isSmallScreen()) {
            return;
        }
        const counter = benefitsFirstColumn.querySelector('.counter');
        const text = benefitsFirstColumn.querySelector('.text');
        const title = benefitsFirstColumn.querySelector('.title');
        const index = benefitsQuestionBoxes.indexOf(benefitBox);
        const newText = benefitBox.querySelector('.answer');
        const newTitle = benefitBox.querySelector('.title');
        benefitsQuestionBoxes.forEach((box) => {
            box.classList.remove('active');
        });
        benefitBox.classList.add('active');
        if (counter && text && title && newTitle && newText) {
            counter.innerText = String(index + 1);
            text.innerHTML = newText.innerHTML;
            title.innerHTML = newTitle.innerHTML;
        }
    }
    if (benefitsQuestionBoxes.length === 0) {
        return;
    }
    if (ScreenSize_1.default.isSmallScreen() === false) {
        benefitsQuestionBoxes[0].classList.add('active');
    }
    benefitsQuestionBoxes.forEach((box) => {
        box.addEventListener('click', () => {
            showBenefit(box);
        });
    });
    window.addEventListener('resize', () => {
        if (ScreenSize_1.default.isSmallScreen() === true) {
            return;
        }
        const activeBox = getActiveBox(benefitsQuestionBoxes);
        if (activeBox === null) {
            return;
        }
        showBenefit(activeBox);
    });
    navigations.forEach((nav) => {
        nav.addEventListener('click', () => {
            const toRight = nav.classList.contains('right');
            const activeBox = getActiveBox(benefitsQuestionBoxes);
            if (activeBox === null) {
                return;
            }
            const activeBoxIndex = benefitsQuestionBoxes.indexOf(activeBox);
            const firstBoxIndex = 0;
            const lastBoxIndex = benefitsQuestionBoxes.length - 1;
            let nextBox;
            if (toRight === true) {
                nextBox = activeBoxIndex === lastBoxIndex ? benefitsQuestionBoxes[firstBoxIndex] : activeBox.nextElementSibling;
            }
            else {
                nextBox = activeBoxIndex === firstBoxIndex ? benefitsQuestionBoxes[lastBoxIndex] : activeBox.previousElementSibling;
            }
            if (nextBox) {
                showBenefit(nextBox);
            }
        });
    });
})();
